// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitHeader__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitHeader/SearchUnitHeader.scss
 ** module id = 938
 ** module chunks = 1
 **/